import { request } from "../../utils/request";
export const getJsonConfig = (key) => {
  return request.get("/api/v1/config/configKey/" + key);
};
export const getAgentMssages = () => {
  return request.get("/api/agent/messages");
};

export const ttsCosUrl = (param) => {
  return request.post(
    "https://zcxm-api.chinasme.cn/api/txyun/ttsCosUrl",
    param
  );
};

export const playMessage = (message, url) => {
  return request.post(`${url}/human`, {
    type: "echo",
    text: message,
  });
};

export const stopAudio = (url) => {
  let result;
  try {
    result = request.post(`${url}/stop_audio`, {});
  } catch (error) {
    console.log(error, "error");
  }
  return result;
};

export const getPlayState = (url) => {
  return request.post(`${url}/audio_state`, {}).catch(() => {});
};
